import React, { FC } from 'react';
import { Container, Title, Icon } from './styles';
import { Props } from './types';

const Placeholder: FC<Props> = ({ message }) => {
  return (
    <Container>
      <Icon />
      <Title>{message}</Title>
    </Container>
  );
};

export default Placeholder;
